import {Store} from '../classes/store';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';
import { AreaTemplate } from '../../../resources/area/area.interface';

@Injectable({
  providedIn: 'root'
})
export class AreaTemplateStore extends Store<AreaTemplate> {

  /** Constructor. */
  constructor(
    private api: ApiLegacyService
  ) {
    super();
  }


  load() {
    this.api.getAreaTemplates().subscribe(areaTemplates => {
      this.setState(areaTemplates);
    });

    return this.state$;
  }
}
